'use client'

import { useEffect } from 'react'
import { hasUserAcceptedCookies } from 'app/utils/cookieConsent'
import { logClientError } from 'app/actions/clientErrorLogging'

function getClientDebugContext() {
    if (typeof window === 'undefined') return {}
    const tz = Intl.DateTimeFormat?.().resolvedOptions?.()?.timeZone
    return {
        userAgent: navigator.userAgent ?? null,
        language: navigator.language ?? null,
        timezone: tz ?? null
    }
}

export default function AdInjector() {
    useEffect(() => {
        if (!hasUserAcceptedCookies()) return

        const s = document.createElement('script')
        s.src = 'https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-3369703769146401'
        s.async = true
        s.crossOrigin = 'anonymous'
        document.head.appendChild(s)

        return () => {
            try {
                if (s.parentNode && s.parentNode === document.head) {
                    document.head.removeChild(s)
                }
            } catch (error) {
                if (typeof window === 'undefined') return

                const ctx = getClientDebugContext()
                const errorMessage =
                    (error instanceof Error ? error.message : typeof error === 'string' ? error : String(error)) ||
                    'Unknown error'

                const base = {
                    message: `AdInjector cleanup removeChild failed: ${errorMessage}`,
                    stack: error instanceof Error ? (error.stack ?? null) : null,
                    url: window.location.href,
                    referrer: document.referrer || '',
                    // Caught and non-crashing – treat as warning-level
                    caught: true,
                    severity: 'warning' as const,
                    ...ctx
                }

                // Enrich with build info when available, mirroring ErrorBoundary logging
                fetch('/api/build-info')
                    .then(r => r.json())
                    .then((info: Record<string, unknown>) => {
                        logClientError({
                            ...base,
                            buildTimestamp: (info.buildTimestamp as string) ?? null,
                            gitCommitHash: (info.gitCommitHash as string) ?? null,
                            vercelDeploymentId: (info.vercelDeploymentId as string) ?? null,
                            vercelRegion: (info.vercelRegion as string) ?? null
                        })
                    })
                    .catch(() => {
                        logClientError(base)
                    })
            }
        }
    }, [])

    return null
}
